import { IRadioOption } from 'transfix-form/components/ControlledRadioGroupInput'
import { IShipperRateTypes } from 'types/graphqlTypes'

export const SHIPPER_RATE_TYPE_OPTIONS: IRadioOption[] = [
  {
    id: IShipperRateTypes.contract_primary,
    label: 'Contract',
  },
  {
    id: IShipperRateTypes.contract_backup,
    label: 'Backup/Published',
  },
  {
    id: IShipperRateTypes.spot,
    label: 'Spot',
  },
]
